module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Playlist#2-9e5e4c939ffd80ee45bcae4534ce2506.svg";